import { createContext, useMemo, useState } from "react";
import type { ReactNode } from "react";

interface Ctx {
  sessionId: string | null;
  start: () => void;
  join: (sessionId: string) => void;
  leave: () => void;
}

export const ListenTogetherContext = createContext<Ctx | null>(null);

export function ListenTogetherProvider({ children }: { children: ReactNode }) {
  const [sessionId, setSid] = useState<string | null>(null);
  const value = useMemo<Ctx>(() => ({
    sessionId,
    start: () => setSid(crypto.randomUUID()),
    join: (id) => setSid(id),
    leave: () => setSid(null),
  }), [sessionId]);
  return <ListenTogetherContext.Provider value={value}>{children}</ListenTogetherContext.Provider>;
}
